import { AlertCircle, RefreshCw } from 'lucide-react'

export function DashboardQueryError(props: {
	title: string
	description: string
	retryLabel: string
	isRetrying: boolean
	onRetry: () => void
}) {
	return (
		<div className='dashboard-query-state' role='alert'>
			<AlertCircle aria-hidden='true' />
			<div>
				<h3>{props.title}</h3>
				<p>{props.description}</p>
			</div>
			<button
				className='portal-button portal-button--secondary portal-button--small'
				disabled={props.isRetrying}
				onClick={props.onRetry}
				type='button'
			>
				<RefreshCw aria-hidden='true' />
				{props.retryLabel}
			</button>
		</div>
	)
}

export function DashboardQueryLoading(props: { label: string }) {
	return (
		<output
			aria-busy='true'
			aria-label={props.label}
			className='dashboard-query-loading'
		>
			<span className='dashboard-query-loading__line' />
			<span className='dashboard-query-loading__line dashboard-query-loading__line--short' />
			<span className='sr-only'>{props.label}</span>
		</output>
	)
}
